// src/js/app.js

$(document).ready(function() {




    $('a[href^="#"]:not([href="#"])').click(function (e) {
        e.preventDefault();

        var target = $($.attr(this, 'href'));

        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top - 120
            }, 1000);
        }
    });



const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) entry.target.classList.add('visible');
    });
}, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

});



$(document).foundation();
